
const base = {
  yes: 'Ja',
  no: 'Nee',
  next: 'Volgende',
  prev: 'Vorige',
  back: 'Terug',

  notifications: 'Meldingen',
  apply: 'Donatie aanvragen',
  dashboard: 'Mijn dashboard',
  profile: 'Profiel',
  logout: 'Uitloggen',

  organisation_users: 'Gebruikers gekoppeld aan deze organisatie',
}

export default base;